import { toBN } from '@utils/formaters.utils';

export enum SortDestination {
  Asc = 'ASC',
  Desc = 'DESC',
}

export const DEFAULT_DELAY = 400;

export const DEBANK_PROFILE = 'https://debank.com/profile';

export const APP_URL = 'https://dexfi.com';

export const PERCENT_DIVIDER = 100;

export const WHITE_LIST_ADDRESS = [
  '0xBfd8194f7cC17D2f4f324E440F47571D845bcfFF',
  '0x1BD2532843Cc60168cc657cE296C9F2144c62FCe',
  '0xe876d4cee7deD8119b345a5b83Be7Cbf157512F0',
  '0x6591603699a486A2Fa4E3982bAD1B42AB068cbc5',
  '0x9544e0500407dad0765b11c67D6c94645Cf343Ca',
  '0x63dc84c5516ed20c908bad86fa09e6155d093b47',
  '0x21f4dD6c491E04874f19F6Bc4fc1a3d0e661Ca39',
  '0xaFe186232442a29D829bd38c6BEA35FBa6AfBaa0',
  '0x9F8c00617B6Ce581A38a8022D765656b261c82ef',
  '0xBA280da36aCA44F18731bcC646326069352ad006',
  '0x27a9B10213cD659467CDFfE2Eb8eBaedbdA3A57e',
  '0xb61B9F2B1870F8595A3aacAa607297C41aA33841',
  '0x3e83C272A94fC713974f5c95aA7CFbbe04234298',
  '0x79B51925e96bcDEBA07a58e0E17386dEfF8b655A',
  '0x77AE0aee8b723B2E012C9E1D5308664c20896A04',
];

export const DAYS_PER_WEEK = 7;

export const DAYS_PER_YEAR = 365;

export const SECONDS_PER_DAY = 24 * 60 * 60;

export const SECONDS_PER_WEEK = SECONDS_PER_DAY * DAYS_PER_WEEK;

export const SECONDS_PER_YEAR = SECONDS_PER_DAY * DAYS_PER_YEAR;

export const MIN_MINOR_FRACTION = 3;

export const MIN_VISIBLE_THRESHOLD = toBN('0.01');
